module.exports = __webpack_public_path__ + "img/location.1725ab1c.svg";